module.exports = __webpack_public_path__ + "static/media/dropdown-down-icon.da8bb2e7.png";